import * as scrollController from './inc/rk-scroll-controller'
import * as animations from './inc/rk-animations'
import * as sliders from './inc/rk-sliders'
import { initializeNavbar } from './inc/rk-navbar'
import { initializeNeighbourhood } from './inc/rk-neighbourhood'
import { initializeHomes } from './inc/rk-homes'
import { initializeThankYouPCPage } from './inc/rk-thank-you-pc'

const pageReady = () => {
  if (document.querySelector('#wrapper-navbar'))
    initializeNavbar()

  animations.initializeGlobalAnimations()

  if (document.body.classList.contains('home')) {
    scrollController.init()
    scrollController.initRegisterButtonScroll()
    animations.initializeHomeAnimations()
  }

  if (document.body.classList.contains('page-neighbourhood')) {
    initializeNeighbourhood()
    animations.initializeNeighbourhoodAnimations()
  }

  if (document.body.classList.contains('page-homes')) {
    initializeHomes()
    animations.initializeHomesAnimations()
  }

  if (document.body.classList.contains('page-streetside')) {
    const streetsideGallerySlider = document.querySelector('.streetside-gallery .swiper')
    sliders.initializeSlider(streetsideGallerySlider)
  }

  if (document.body.classList.contains('page-thank-you') || document.body.classList.contains('page-thank-you-pc-form')) {
    animations.initializeThankYouAnimations()
  }

  if (document.body.classList.contains('page-thank-you-pc-form')) {
    initializeThankYouPCPage()
  }
}

if (
  document.readyState === 'complete'
  || (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
  pageReady()
} else {
  document.addEventListener('DOMContentLoaded', pageReady)
}
